import { ActionContext } from 'vuex';
import { IAppRootState } from './IAppRootState';
import { TjipVuexAction, TjipVuexMutation } from '@tjip/vuejs';
import { AppSessionStoreDataModule } from './AppSessionStoreDataModule';
import { appBerichtenService } from '@/services/appBerichtenService';
import { IBericht } from '@/model/IBericht';

export class AppBerichtenDataModule extends AppSessionStoreDataModule<IBericht[], IAppRootState> {
  public namespaced = true;

  constructor() {
    super('berichten', []);
  }

  @TjipVuexAction
  private getBerichten(ctx: ActionContext<IBericht[], IAppRootState>, force = false): Promise<IBericht[]> {
    if (force) {
      return appBerichtenService.getBerichten(force).then((berichten: IBericht[]) => {
        ctx.commit('getBerichtenSucceeded', berichten);
        return ctx.state;
      });
    }
    return Promise.resolve(ctx.state);
  }

  @TjipVuexMutation
  private getBerichtenSucceeded(state: IBericht[], value: IBericht[]) {
    state.splice(0, state.length, ...value);
    //    Object.assign(state, config);
  }

  @TjipVuexAction
  protected logout(ctx: ActionContext<IBericht[], IAppRootState>) {
    ctx.dispatch('reset');
  }

  @TjipVuexAction
  protected markAsRead(ctx: ActionContext<IBericht[], IAppRootState>, bericht: IBericht) {
    if (!bericht.gelezen) {
      bericht.gelezen = true;
      appBerichtenService.markAsRead(bericht.berichtId);
    }
  }

  private static hashCode(bericht: IBericht): number {
    const s = `${bericht.datum}#${bericht.onderwerp}`;
    let h = 0;
    for (let i = 0; i < s.length; i++) {
      h = (Math.imul(31, h) + s.charCodeAt(i)) | 0;
    }

    return h;
  }
}
